import { Link } from 'react-router-dom';
import { categories } from '@/mocks/articles';

export default function Footer() {
  return (
    <footer className="bg-foreground-950 text-white">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <h4 className="text-base font-semibold mb-4" style={{ fontFamily: 'var(--font-heading)' }}>
              羊宫妃那词条百科
            </h4>
            <p className="text-sm text-white/60 leading-relaxed">
              探索网络文化的深度与温度，用严谨的态度解读每一个网络流行语。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold mb-4 uppercase tracking-wider text-white/50">
              分类导航
            </h4>
            <ul className="space-y-2.5">
              {categories.map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-white/60 hover:text-white transition-colors"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold mb-4 uppercase tracking-wider text-white/50">
              热门文章
            </h4>
            <ul className="space-y-2.5">
              <li>
                <Link
                  to="/article/yangongfei-wo-lai-cao-ni-le"
                  className="text-sm text-white/60 hover:text-white transition-colors"
                >
                  词条完全解析
                </Link>
              </li>
              <li>
                <Link
                  to="/article/yangongfei-hina-profile"
                  className="text-sm text-white/60 hover:text-white transition-colors"
                >
                  羊宫妃那个人资料
                </Link>
              </li>
              <li>
                <Link
                  to="/article/mygo-phenomenon"
                  className="text-sm text-white/60 hover:text-white transition-colors"
                >
                  MyGO!!!!! 现象
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold mb-4 uppercase tracking-wider text-white/50">
              关于
            </h4>
            <ul className="space-y-2.5">
              <li>
                <Link
                  to="/about"
                  className="text-sm text-white/60 hover:text-white transition-colors"
                >
                  品牌介绍
                </Link>
              </li>
              <li>
                <Link
                  to="/about"
                  className="text-sm text-white/60 hover:text-white transition-colors"
                >
                  联系我们
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-sm text-white/40">
            &copy; {new Date().getFullYear()} 羊宫妃那词条百科. All rights reserved.
          </p>
          <div className="flex items-center gap-5">
            <a href="#" className="text-white/40 hover:text-white/70 transition-colors" rel="nofollow">
              <i className="ri-weibo-line text-lg"></i>
            </a>
            <a href="#" className="text-white/40 hover:text-white/70 transition-colors" rel="nofollow">
              <i className="ri-bilibili-line text-lg"></i>
            </a>
            <a href="#" className="text-white/40 hover:text-white/70 transition-colors" rel="nofollow">
              <i className="ri-github-line text-lg"></i>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}